/**
 * Technologie-Versionen für About-Reiter (zur Laufzeit ermittelt)
 */
import React from 'react';

export const getTechVersions = () => {
  const v = {};
  try {
    v.React = React.version;
  } catch (_) {
    v.React = '?';
  }
  try {
    v.i18next = require('i18next/package.json').version;
  } catch (_) {
    v.i18next = '?';
  }
  try {
    v['react-router-dom'] = require('react-router-dom/package.json').version;
  } catch (_) {
    v['react-router-dom'] = '?';
  }
  try {
    v.workbox = require('workbox-window/package.json').version;
  } catch (_) {
    v.workbox = '?';
  }
  return v;
};
